/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OccupationControllerService {
    /**
     * @returns any Array of occupation with selected scopes
     * @throws ApiError
     */
    public static occupationControllerGetOccupation(): CancelablePromise<Array<{
        id?: string;
        displayName?: string;
        category?: string;
        occupations?: Array<{
            id?: string;
            displayName?: string;
        }>;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/occupation',
        });
    }
}
